<script setup lang="ts">
import { HorizontalProps } from "~/components/Banner/DiscountPromo/Horizontal.props"
import type { DiscountCodeProps as Discount } from "~/components/Card/DiscountCode.props"

const { locale, t } = useI18n()

const { data, error } = await usePage(
  `/api/gluon/fetchPromotionListingPage/${locale.value}/promotion_listing.js`
)

const { discountCodes } = useDiscountCodes()

const discountCodeWelcome: ComputedRef<Discount | undefined> = computed(() => {
  if (discountCodes.value) {
    return discountCodes.value.find((code: Discount) =>
      code.discountCode.includes("BENVENUTO")
    )
  }
})

const posterDiscountCode = computed((): HorizontalProps | undefined => {
  if (discountCodeWelcome.value) {
    return {
      title: t("plp.banners.promoCode.title"),
      text: t("plp.banners.promoCode.title", {
        promoValue: discountCodeWelcome.value?.discountCode
      }),
      bgImageLarge: getImageData({
        altText: "Placeholder",
        url: "/i5oh5hzamkwo/18QbocGJ6QeY0bt92YZJZ3/dddd98593ae511993aef476a0ef9c494/BannerPLP.svg",
        width: 348,
        height: 397
      }),
      cta: { text: t("plp.banners.promoCode.ctaLabel") },
      cardType: "withPromoCode",
      promoCode: discountCodeWelcome.value?.discountCode,
      promoCodeInfoText: t("plp.banners.promoCode.promoCodeInfoText"),
      promoCodeInfoTextCopied: t(
        "plp.banners.promoCode.promoCodeInfoTextCopied"
      ),
      promoTextCopied: t("plp.banners.promoCode.promoTextCopied")
    }
  }
})

const { data: allPromotionsBrand } = await useFetch(
  "/api/getAllPromotionsBrand",
  {
    transform: (d) => {
      const withPreload = d.map((promo, ix) => {
        return {
          ...promo,
          promotionImage: {
            ...promo.promotionImage,
            preload: ix < 3,
            imgAttrs: { fetchpriority: ix < 3 ? "high" : "auto" }
          }
        }
      })
      return posterDiscountCode.value
        ? [
            ...withPreload.slice(0, 5),
            posterDiscountCode.value,
            ...withPreload.slice(5)
          ]
        : withPreload
    }
  }
)

if (error.value) {
  throw createError({
    message: error.value.message,
    statusCode: error.value.statusCode ?? 404
  })
}
</script>

<template>
  <SeoBase v-if="data?.seo" v-bind="data?.seo" />
  <PagesPromotion v-bind="data" :all-promotions-brand="allPromotionsBrand" />
</template>
